<template>
    <div class="card-body">
        <table class="table">
            <tbody>
                <SettingTreeTableRow
                    v-for="item in data"
                    :key="item.name"
                    :item="item"
                    @toggle="toggleRow"
                    @edit="editSetting"
                />
            </tbody>
        </table>
    </div>
</template>

<script>
import SettingTreeTableRow from '@/components/GeneralComponents/SettingTreeTableRow';
import { SettingsState } from '@/stores/pages/Admin/Settings.ts';

export default {
    components: {
        SettingTreeTableRow
    },
    props: {
        data: {
            type: Array,
            required: true
        }
    },
    data() {
        const settingsState = SettingsState();
        return {
            settingsState,
        };
    },
    methods: {
        toggleRow(itemKey) {
            this.settingsState.toggleKey(itemKey)
        },
        editSetting(item){
            this.$emit('edit', item);
        }
    }
}
</script>

<style>
.treeIcon {
    margin-left: 1em;
    margin-right: 1em;
}
.itemIcon {
    margin-left: -1em;
    margin-right: -1em;
}
.card-body {
    overflow-x: auto;
}
</style>
